/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateClientGroupDto
 */
export interface CreateUpdateClientGroupDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientGroupDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientGroupDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateClientGroupDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the CreateUpdateClientGroupDto interface.
 */
export function instanceOfCreateUpdateClientGroupDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function CreateUpdateClientGroupDtoFromJSON(json: any): CreateUpdateClientGroupDto {
    return CreateUpdateClientGroupDtoFromJSONTyped(json, false);
}

export function CreateUpdateClientGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateClientGroupDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'active': json['active'],
    };
}

export function CreateUpdateClientGroupDtoToJSON(value?: CreateUpdateClientGroupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'active': value.active,
    };
}

